import * as React from 'react';

import createLogger from '../../utils/createLogger';
import {createDidError, createIsLoading} from "../../data/requests/requestsSelectors";
import {connect} from "react-redux";
import {Button} from "../static/Elements";
import Icon from '../static/Icons';
import renderHTML from 'react-render-html';
import {getCompanyRecents, putDuplicateJob} from "../../data/jobs/jobActions";
import {companySelector, createJobSelector} from "../../data/jobs/jobSelectors";
import Header from "../static/Header";
import {Loading} from "../static/Indicators";

const DEBUG = true;
const debug = createLogger(DEBUG, `DuplicateCheck.js`);


const mapStateToProps = (state, ownProps) => {
  const isLoading = createIsLoading(DuplicateCheck.dependencies);
  const didError = createDidError(DuplicateCheck.dependencies);
  const jobSelector = createJobSelector(ownProps.id);
  const companyId = ownProps.companyId;

  return {
    isAuthenticated: !!state.auth.session,
    isLoading: isLoading(state),
    didError: didError(state),
    job: jobSelector(state),
    company: companySelector(state, companyId),
    companyRecents: state.jobs.companyRecents,
  }
};

const mapDispatchToProps = {
  getCompanyRecents,
  putDuplicateJob,
};

class DuplicateCheck extends React.Component {

  static dependencies = [
    'GET_COMPANY_RECENTS',
    'PUT_DUPLICATE_JOB',
  ];

  proceed = () => {
    this.props.returnToLead(this.props.companyId);
  };

  update = (_id) => () =>{
    const {putDuplicateJob, job, closeModal, selectNext, matchUrl} = this.props;
    debug.log('updating job with jobleadid: ', _id);
    job['matchUrl'] = matchUrl;
    selectNext ();
    putDuplicateJob(_id, job);
    closeModal ();
  };

  render () {
    const {
      title,
      location,
      posted,
      description,
    } = this.props.job;

    const date = posted ? new Date(posted).toUTCString().substr(5, 11) : null;

    const {proceed, update} = this;
    const {isLoading} = this.props;
    const {companyRecents, company} = this.props;

    if (isLoading) {
      return (
        <Loading/>
      )
    }

    return (
      <div className='duplicate-check'>
        <div className="current-lead">
          <article>
            <div>
              <Header smallHeader={true} title={title}>
                {company['companyname']} <br/>
                {location} <br/>
                Posted {date} <br/>
              </Header>
            </div>
            <div className="description-container">
              {renderHTML (description)}
            </div>

          </article>
        </div>
        <div className="potential-duplicate-list">
          <h5>If the lead has already been found, select it below to update it</h5>
          {
            companyRecents.map(j => (
              <PotentialDuplicate job={j} key={j['jobleadid']} company={company} select={update}/>
            ))
          }
          <div className="proceed">
            <Button key='1' primary onClick={proceed}>Proceed</Button>
          </div>
        </div>
      </div>
    )
  }
}

class PotentialDuplicate extends React.Component {

  constructor (props) {
    super (props);
    this.state = {
      expanded: false,
    }
  }

  toggleExpanded = () => {
    this.setState({expanded: !this.state.expanded});
  };

  render () {

    const {
      enddate,
      jobtitle,
      joblocation,
      jobdescription,
    } = this.props.job;

    const {companyname} = this.props.company;

    const {expanded} = this.state;

    const date = enddate ? new Date(enddate).toUTCString().substr(5, 11) : null;

    return (
      <div className="potential-duplicate">
        <div className={expanded? "potential-duplicate-info" : "potential-duplicate-info expanded"}>
          <h6>{jobtitle}</h6>
          <p>{companyname}</p>
          <p>{date}</p>
          <p>{joblocation}</p>
          {
            expanded ? (
              renderHTML(jobdescription)
            ) : null
          }
        </div>
        <div className="potential-duplicate-actions">
          <Button onClick={this.props.select(this.props.job['jobleadid'])}>
            <Icon.Input/>
          </Button>
          <Button text onClick={this.toggleExpanded}>
            <Icon.Caret isOpen={expanded}/>
          </Button>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DuplicateCheck);


// WEBPACK FOOTER //
// ./src/components/AgencyPostings/DuplicateCheck.js